// extracted by mini-css-extract-plugin
export default {"disclaimer":"onfido-sdk-ui-ActiveVideo-Disclaimer-disclaimer","text":"onfido-sdk-ui-ActiveVideo-Disclaimer-text"};